import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Price from 'Containers/Utility/Price/Price';

export default function ProductPrice({ price, className }) {
  return (
    <div className="PriceContainer">
      <div className={classNames('PriceContainer__price', className)}>
        <b>
          <Price
            price={price}
          />
        </b>
      </div>
    </div>
  );
}

ProductPrice.propTypes = {
  price: PropTypes.shape({}),
};

ProductPrice.defaultProps = {
  price: {},
};
